import { Action, createReducer, on } from '@ngrx/store';
import { SearchType } from '@search-bar/entities/search-type';

import {
  setTabSelectedHome,
} from '@shared/base-search-bar/store/actions/search-bar.actions';

export const initialState = SearchType.HOME_FLIGHT;

const featureReducer = createReducer(
  initialState,
  on(setTabSelectedHome, (state, { value }) => value)
);

export const tabSelectedHomeReducer = (state: SearchType | undefined = SearchType.HOME_FLIGHT, action: Action): SearchType => {
  return featureReducer(state, action);
};
